exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".errorMsg[data-v-642da855]{width:330px;display:-webkit-box;display:-ms-flexbox;display:flex;background-color:#ffe7d9;border-radius:8px;//align-items:center;margin:0 auto;padding:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-642da855","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/errorMsg/errorMsg.vue
// module id = 320
// module chunks = 0